import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";

import Alert from "../../app/components/common/Alert";
import LoadingButton from "../../app/components/common/LoadingButton";

const ResetPassword = () => {
  const { pathname } = useLocation();
  const [loginFormLoading, setLoginFormLoading] = useState(false);

  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);

  const [apiErrors, setApiErrors] = useState(null);
  console.log("🚀 ~ Login ~ apiErrors:", apiErrors);

  const navigate = useNavigate(); // we can pass navigation to clickhandler
  // console.log(isAccessTokenValid)
  const inputObj = {
    history: navigate,
    // accessToken: useSelector(isAccessTokenValid),
    errorHandler: setApiErrors,
    loadingHandler: setLoginFormLoading,
  };
  // console.log(inputObj)
  useEffect(() => {
    //const error = useSelector(readServerError);
    console.log("isUserAuthenticated", isUserAuthenticated);
    // redirectToDashboardPageIfTokenIsValid(inputObj);
  }, [isUserAuthenticated]);
  // let store = AppStore.getAppStoreInstance();

  useEffect(() => {
    if (apiErrors != null) {
      setTimeout(() => {
        setApiErrors(null);
      }, 2500);
    }
  }, [apiErrors]);

  return (
    <>
      {apiErrors != null && (
        <div
          className="position-absolute d-flex w-100 justify-content-center"
          //   style={{ top: alertType == "danger" ? "100px" : "140px" }}
        >
          <Alert message={apiErrors?.message} alertType={"danger"} />
        </div>
      )}
      <main className="d-flex w-100 h-100">
        <div className="container d-flex flex-column">
          <div className="row vh-100">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className={`d-table-cell ${pathname === "/profile/reset-password" ? "" : "align-middle"} `}>
                <div className={`text-center ${pathname === "/profile/reset-password" ? "mt-5" : ""}`}>
                {pathname === "/profile/reset-password" ? "" : 
                  <h1 className="h2">Welcome Xoptin Ads</h1>
      }
                  <p className="lead">Reset your password to continue</p>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="m-sm-4">
                      {pathname === "/profile/reset-password" ? "" : 
                      <div className="d-flex justify-content-center" onClick={()=> navigate('/login')}>
                        <img
                          src="xoptin_logo.png"
                          alt="Charles Hall"
                          className="img-fluid mb-5"
                          // width="280"
                          // height="132"
                        />
                      </div>
                      }
                      <Formik
                        initialValues={{ email: "", password: "" }}
                        validationSchema={Yup.object({
                          email: Yup.string()
                            .email("Invalid email address")
                            .required("This field is required"),
                          password: Yup.string().required(
                            "This field is required"
                          ),
                        })}
                        onSubmit={(values, actions) => {
                          // Handle form submission
                          console.log("Login Submit handler called!");
                          setLoginFormLoading(true)
                          values.setIsUserAuthenticated =
                            setIsUserAuthenticated;
                          console.log(values);
                          values.history = inputObj.history;
                          values.errorHandler = inputObj.errorHandler;
                          values.loadingHandler = inputObj.loadingHandler;

                          // loginBtnClickHandler(values);
                        }}
                      >
                        <Form className="text-start">
                          <div className="mb-3">
                            <label className="form-label">Email</label>
                            <Field
                              type="email"
                              id="email"
                              name="email"
                              className="form-control form-control-lg"
                              required
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                            <small>
                              <a href="" onClick={(e)=> {e.preventDefault(); navigate('/login')}}>
                                Back to login!
                              </a>
                            </small>
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                            </div>
                          </div>
                          

                          <div className="d-flex justify-content-center mt-3">
                            {loginFormLoading ? (
                              <LoadingButton size='btn-lg' name="Reset Password"/>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-lg btn-primary"
                              >
                                Reset Password
                              </button>
                            )}
                          </div>
                        </Form>
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ResetPassword;
